<template>
  <el-dialog title="两点报警"
             :visible.sync="dialogShow"
             v-dialogDrag
             width="60%"
             @close="dialogClose"
             :close-on-click-modal="false">
    <div class="content-container flex-row">
      <!-- 左侧列表 -->
      <div class="content-left"
           v-loading="drawLoading"
           element-loading-text="详情加载中"
           element-loading-spinner="el-icon-loading">
        <div class="ioc-drawer__header map-blur-panel__title">
          <div class="slot-title"
               :title="'【' + multiAlarmInfo.subSystemLabel + '】' + multiAlarmInfo.alarmName">
            {{ '【' + multiAlarmInfo.subSystemLabel + '】' + multiAlarmInfo.alarmName }}
          </div>
        </div>
        <div class="alarm-title">告警详情</div>
        <el-scrollbar class="flex-auto ioc__scrollbar">
          <div class="twodetail-container">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">告警级别：{{multiAlarmInfo.alarmLevel | dic("SENU017")}}</div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">设备名称：{{ multiAlarmInfo.subDeviceMark ? multiAlarmInfo.parentDeviceName : multiAlarmInfo.deviceName }}</div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">类型：{{ multiAlarmInfo.deviceType | dic("SENU087") }}</div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">厂商：{{ multiAlarmInfo.subDeviceMark ? multiAlarmInfo.parentFactoryName : multiAlarmInfo.factoryName }}</div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">IP地址：{{ multiAlarmInfo.subDeviceMark ? multiAlarmInfo.parentIp : multiAlarmInfo.ip }}</div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">唯一标识号：{{ multiAlarmInfo.subDeviceMark ? multiAlarmInfo.parentThirdAlarmDevId : multiAlarmInfo.thirdAlarmDevId }}</div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">所在位置：{{ multiAlarmInfo.buildingName }}</div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">告警时间：{{ multiAlarmInfo.alarmTime | moment }}</div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">告警描述：{{ multiAlarmInfo.desc }}</div>
              </el-col>
              <!-- 部件详情 -->
              <el-col :span="24"
                      v-if="multiAlarmInfo.subDeviceMark">
                <div class="grid-content bg-purple-dark">回路：{{ multiAlarmLoopText }}</div>
              </el-col>
              <el-col :span="24"
                      v-if="multiAlarmInfo.subDeviceMark">
                <div class="grid-content bg-purple-dark">部件名称：{{ multiAlarmInfo.deviceName }}</div>
              </el-col>
              <el-col :span="24"
                      v-if="multiAlarmInfo.subDeviceMark">
                <div class="grid-content bg-purple-dark">部件类型：{{ multiAlarmInfo.subDeviceMark | dic("SENU094") }}</div>
              </el-col>
              <el-col :span="24"
                      v-if="multiAlarmInfo.subDeviceMark">
                <div class="grid-content bg-purple-dark">部件地址：{{ multiAlarmAddressText }}</div>
              </el-col>

            </el-row>
            <!-- 两点报警关联告警 -->
            <el-table :data="relationList"
                      style="width: 100%"
                      highlight-current-row
                      @row-click="alarmRowClick"
                      max-height="300">
              <el-table-column type="index"
                               label="序号"
                               width="50">
              </el-table-column>
              <el-table-column prop="alarmName"
                               label="告警名称"
                               width="180">
              </el-table-column>
              <el-table-column prop="alarmTime"
                               label="告警时间"
                               :formatter="formatterTime">
              </el-table-column>
            </el-table>
          </div>
        </el-scrollbar>
      </div>
      <!-- 右侧视频 -->
      <div class="content-right page-background-color"
           id="video-container">
           <span style="color: #b3cbf1;font-size:12px;">关联告警序号{{currentPage}}视频</span>
        <VideojsPlayerNew ref="player"
                          style="height:calc( 100% - 28px);color:#fff"
                          :windowNumber="windowNumber"></VideojsPlayerNew>
        <!-- 底部 -->
        <div class="video-bottom flex-row">
          <!-- <button type="button"
                  :disabled="currentPage === 0"
                  class="btn-prev"
                  @click="prevClick">
            <i class="el-icon el-icon-arrow-left"></i>
          </button> -->
          <!-- 中间条数 -->
          <!-- <div class="video-number flex-row"
               v-for="(item, index) in relationList"
               :key="index">
            <div class="number"
                 :class="{ active: index === currentPage }"
                 @click="videoNumberClick(item, index)">序号{{index+1}}关联视频</div>
          </div>
          <button type="button"
                  :disabled="currentPage == relationList.length-1 || relationList.length ==0"
                  class="btn-next"
                  @click="nextPage">
            <i class="el-icon el-icon-arrow-right"></i>
          </button> -->
          <el-pagination background
                         :page-size="1"
                         :page-sizes="[1]"
                         layout="prev, pager, next"
                         :current-page="currentPage"
                         @current-change="handleCurrentChange"
                         :total="relationList.length">
          </el-pagination>
        </div>
      </div>
    </div>

  </el-dialog>
</template>
<script>
import { api } from "../api";
import { Dates } from "@src/common/utils";
import utils from '@src/common/utils'
import VideojsPlayerNew from '@src/components/common/media-player/video-playerNew.vue'
export default {
  components: {
    VideojsPlayerNew
  },
  props: {
    // websocketId: {
    //   type: String,
    //   default: ''
    // },
  },
  data () {
    return {
      drawLoading: false,
      dialogShow: false,
      multiAlarmInfo: {},
      multiAlarmLoopText: '',
      multiAlarmAddressText: '',
      windowNumber: 4,
      relationList: [],
      websocketId: '',
      clickFlag: false,
      currentPage: 1,
      alarmDeviceId: ''
    };
  },
  beforeRouteLeave (to, from, next) {

  },
  deactivated () {

  },
  beforeDestroy () {

  },

  created () {

  },
  mounted () {
    // this.getTwoPointAlarmDetails(20210416000081, 1);
  },
  methods: {
    showAlarmDialog (id, deviceId, flag) {
      this.drawLoading = false;
      this.dialogShow = true;
      this.websocketId = id;
      this.clickFlag = flag;
      this.alarmDeviceId = deviceId;
      this.getTwoPointAlarmDetails(this.websocketId);
      this.getDeviceVideo(this.alarmDeviceId)
    },
    //时间格式化 
    formatterTime (row) {
      return utils.Dates.dayjs(row.alarmTime).format('YYYY-MM-DD HH:mm:ss')
    },
    // 获取告警详情
    getTwoPointAlarmDetails (id) {
      let params = {
        alarmId: id
      }
      this.$fetch(api.alarm.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.multiAlarmInfo = response.returnObj;
          if (this.clickFlag) {
            this.relationList = response.returnObj.relationAlarmInfoList;
          }
          if (this.multiAlarmInfo.thirdAlarmDevId && this.multiAlarmInfo.subDeviceMark) {
            let arr = this.multiAlarmInfo.thirdAlarmDevId.split("-")
            if (arr.length === 3) {
              this.multiAlarmLoopText = arr[1]
              this.multiAlarmAddressText = arr[2]
            } else {
              this.multiAlarmLoopText = arr[2]
              this.multiAlarmAddressText = arr[3]
            }
          }
        } else {
          this.$message.error(response.msgContent || "获取消防告警详情失败");
        }
      })
    },
    // 表格行点击事件
    alarmRowClick (row) {
      this.clickFlag = false;
      this.getTwoPointAlarmDetails(row.alarmId)
    },
    // 根据alarmDevId设备ID查找告警关联的视频
    getDeviceVideo (val) {
      if (this.$refs.player) {
        this.$refs.player.closeAllVideo();
      }
      console.log("关闭所有video")
      this.$nextTick(() => {
        this.$fetch(api.alarm.getDeviceVideo, { deviceId: val }).then((res) => {
          if (res && res.success) {
            let deviceList = res.returnObj
            if (deviceList.length) {
              if (deviceList.length > 4) {
                this.windowNumber = 9
              }
              deviceList.forEach((el, index) => {
                if (el.thirdCameraId) {
                  if (index < this.windowNumber) {
                    this.$nextTick(() => {
                      this.$refs.player.playLiveVideo(el, index + 1)
                    })
                  }
                }
              })
            }
          }
        })
      })
    },
    // 上一个视频下一个视频
    prevClick () {
      if (this.currentPage > 0) {
        this.currentPage--
      }
      let deviceId = this.relationList[this.currentPage].alarmDevId;
      this.getDeviceVideo(deviceId)
    },
    // 下一页
    nextPage () {
      if (this.currentPage <= this.relationList.length - 1) {
        this.currentPage++;
      }
      let deviceId = this.relationList[this.currentPage].alarmDevId;
      this.getDeviceVideo(deviceId)
    },
    // 点击条数查询告警相关的实时视频
    videoNumberClick (item, index) {
      this.currentPage = index;
      this.alarmDeviceId = item.alarmDevId;
      this.$refs.player.closeAllVideo();
      setTimeout(() => {
        this.getDeviceVideo(this.alarmDeviceId)
      }, 500);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.alarmDeviceId = this.relationList[val - 1].alarmDevId;
      this.$refs.player.closeAllVideo();
      setTimeout(() => {
        this.getDeviceVideo(this.alarmDeviceId)
      }, 500);
    },
    dialogClose () {
      if (this.$refs.player) {
        this.$refs.player.closeAllVideo();
      }
      this.dialogShow = false;
      this.currentPage = 1
    },

  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.content-container {
  height: 100%;
  .content-left {
    width: 380px;
    height: 500px;
    @include set_theme_color(background-color, blur-color);
    display: flex;
    flex-direction: column;
    transition: right 0.2s;
    .map-blur-panel__title {
      @include set_theme_color(background-color, blur-color);
      display: flex;
      opacity: 0.8;
      flex-direction: row;
      justify-content: space-between;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      .slot-title {
        max-width: 95%;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-all;
        overflow: hidden;
      }
      .ioc-drawer__close {
        cursor: pointer;
      }
    }
    .alarm-title {
      color: #b3cbf1;
      margin-bottom: 10px;
      font-size: 16px;
      padding: 0 15px;
    }
    .ioc__scrollbar {
      .twodetail-container {
        padding: 0 15px;
        line-height: 30px;
        opacity: 1;
        @include set_theme_color(background-color, blur-color);
        >>> .el-table__row {
          cursor: pointer !important;
        }
      }
    }
  }
  .content-right {
    // flex: 1;
    width: calc(100% - 380px);
    .video-bottom {
      justify-content: center;
      margin: 10px 0px;
      white-space: nowrap;
      padding: 2px 5px;
      color: #303133;
      font-weight: 700;
      .btn-prev,
      .btn-next {
        .el-icon {
          display: block;
          width: 30px;
          font-size: 12px;
          font-weight: 700;
        }
      }
      button {
        display: inline-block;
        font-size: 13px;
        height: 28px;
        line-height: 28px;
        vertical-align: top;
        box-sizing: border-box;
        border: 1px solid;
        border-radius: 2px;
        cursor: pointer;
        background-color: transparent;
        text-align: center;
        margin-right: 8px;
        @include set_theme_color(color, font-default-color);
        @include set_theme_color(border-color, active-border-color);
        &:disabled {
          cursor: not-allowed;
          @include set_theme_color(color, font-disabled-color);
          @include set_theme_color(border-color, font-disabled-color);
          &:hover {
            @include set_theme_color(color, font-disabled-color);
            @include set_theme_color(border-color, font-disabled-color);
          }
        }
        &:hover {
          @include set_theme_color(color, active-border-color);
          @include set_theme_color(border-color, active-border-color);
        }
      }
      .video-number {
        .number {
          margin: 0 5px;
          // color: #dddddd;
          min-width: 30px;
          border-radius: 2px;
          padding: 0 4px;
          font-size: 13px;
          height: 28px;
          line-height: 28px;
          box-sizing: border-box;
          text-align: center;
          border: 1px solid;
          cursor: pointer;
          @include set_theme_color(color, font-default-color);
          @include set_theme_color(border-color, active-border-color);
          &.active {
            @include set_theme_color(background-color, main-button-bgcolor);
            @include set_theme_color(color, font-default-color);
          }
        }
      }
    }
  }
}
</style>
